import { makeStyles, createStyles } from '@material-ui/styles';
import { ITheme } from '../../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    contentWrapper: {
      padding: '24px 0',
      display: 'flex',
      flexWrap: 'wrap',
    },
    item: {
      marginRight: 24,
      marginBottom: 24,
    },
    contentTitle: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    iconWrapper: {
      verticalAlign: 'middle',
      marginTop: 8,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    feedbackLink: {
      [theme.breakpoints.down('xs')]: {
        paddingBottom: '12px',
      },
    },
    linkLabel: {
      fontWeight: 700,
      color: theme.palette.primary.main,
      paddingRight: 24,
      alignItems: 'center',
    },
    contentTopDescription: {
      padding: '16px 0 24px 0',
      maxWidth: '725px',
    },
  }),
);
